import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Calendar, Users, BookOpen, Sparkles, MessageSquare, Settings, LogOut, Home, CreditCard, Brain, Beaker, Megaphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Toaster } from "sonner";

const NAV = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/pricing", label: "Pricing Calendar", icon: Calendar },
  { to: "/admin/leads", label: "Leads", icon: Users },
  { to: "/admin/bookings", label: "Bookings", icon: BookOpen },
  { to: "/admin/payments", label: "Payments", icon: CreditCard },
  { to: "/admin/campaigns", label: "Campaigns & Discounts", icon: Sparkles },
  { to: "/admin/knowledge", label: "AI Knowledge", icon: Brain },
  { to: "/admin/studio", label: "AI Training Studio", icon: Beaker },
  { to: "/admin/broadcast", label: "Broadcast", icon: Megaphone },
  { to: "/admin/chat", label: "WhatsApp Chats", icon: MessageSquare },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const nav = useNavigate();
  const email = localStorage.getItem("mb_email") || "admin";

  const logout = () => {
    localStorage.removeItem("mb_token");
    localStorage.removeItem("mb_email");
    nav("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#F5F2EB] font-body text-[#4A403B]">
      <Toaster position="top-right" richColors/>
      <div className="flex">
        {/* Sidebar */}
        <aside className="w-64 min-h-screen bg-[#FDFBF7] border-r border-[#E7C2A6]/40 flex flex-col" data-testid="admin-sidebar">
          <div className="p-6 border-b border-[#E7C2A6]/40">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#B84F3E] flex items-center justify-center text-white">
                <Home className="w-5 h-5" strokeWidth={1.5}/>
              </div>
              <div>
                <div className="font-serif text-lg leading-none">Megh Balika</div>
                <div className="text-[10px] uppercase tracking-widest text-[#8A7970]">Owner Console</div>
              </div>
            </div>
          </div>
          <nav className="flex-1 p-4">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g,'-')}`}
                className={({isActive}) => `flex items-center gap-3 px-4 py-3 rounded-lg mb-1 text-sm transition-colors ${isActive ? "bg-[#B84F3E] text-white" : "text-[#4A403B] hover:bg-[#F5F2EB]"}`}
              >
                <n.icon className="w-4 h-4" strokeWidth={1.5}/>
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="p-4 border-t border-[#E7C2A6]/40">
            <div className="text-xs text-[#8A7970] mb-2 truncate">{email}</div>
            <Button variant="outline" onClick={logout} className="w-full rounded-md border-[#E7C2A6] text-[#4A403B] hover:bg-[#F5F2EB]" data-testid="admin-logout-btn">
              <LogOut className="w-4 h-4 mr-2" strokeWidth={1.5}/> Logout
            </Button>
          </div>
        </aside>

        {/* Main */}
        <main className="flex-1 p-8">
          <Outlet/>
        </main>
      </div>
    </div>
  );
}
